import { Builder } from '@builder.io/react'
import React, { useEffect, useState } from 'react'

import './index.css'
interface IStepItem {
  stepTitle: string
  stepDescription: string
  stepImage: any
  isJustImage: boolean
}

interface IStepsThreeProps {
  backgroundColor: string
  stepItems: IStepItem[]
  stepTitleColor: string
  stepDescriptionColor: string
}

const clamp = (number: number, min: number, max: number) => {
  return Math.max(min, Math.min(number, max))
}

const StepsThree = ({ backgroundColor, stepItems }: IStepsThreeProps) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleWindowSizeChange = () => {
    if (window.innerWidth <= 640) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  useEffect(() => {
    handleWindowSizeChange()
    window.addEventListener('resize', handleWindowSizeChange)

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  useEffect(() => {
    const svgLine = document.getElementsByClassName('svg-stroke')[0]
    const path: any = svgLine.getElementsByClassName('path')[0]
    const mask: any = svgLine.getElementsByClassName('mask')[0]
    const pathLength = path.getTotalLength()

    console.log('___path length', pathLength)

    path.style.strokeDasharray = pathLength
    path.style.strokeDashoffset = pathLength

    mask.style.strokeDasharray = 10
    mask.style.strokeWidth = 5
    mask.style.stroke = backgroundColor

    const drawLine = () => {
      const windowBottom = document.documentElement.scrollTop + document.documentElement.clientHeight
      const lineParentElement = isMobile
        ? document.getElementById('line-wrapper-mobile')
        : document.getElementById('line-wrapper-desktop')
      const desktopViewElement = document.getElementById('step-items-parent')

      if (lineParentElement && desktopViewElement?.parentElement) {
        const lineOffsetTop = lineParentElement.offsetTop + desktopViewElement.parentElement.offsetTop
        const lineHeight = desktopViewElement.parentElement.offsetHeight - lineParentElement.offsetTop
        console.log('___windowBottom', windowBottom)
        console.log('___top', lineOffsetTop)
        console.log('___parentHeight', lineHeight)
        const ratio = clamp((windowBottom - lineOffsetTop) / lineHeight, 0, 1)
        console.log(`___RATIO`, ratio)

        const drawLength = pathLength * ratio * ratio
        console.log('___drawLen', pathLength - drawLength)
        path.style.strokeDashoffset = pathLength - drawLength
      }
    }

    window.addEventListener('scroll', drawLine)

    return () => {
      window.removeEventListener('scroll', drawLine)
    }
  }, [isMobile])

  const getTextOrImage = (item: IStepItem) => {
    if (!item) return null
    if (item.isJustImage) {
      return <img src={item.stepImage} className="step-image" />
    }
    return (
      <div className="step-text-item">
        <h2 className="step-item-title mb-4 text-5xl sm:text-7xl">{item.stepTitle}</h2>
        <p className="text-lg">{item.stepDescription}</p>
      </div>
    )
  }

  const renderDesktopView = () => {
    if (stepItems) {
      const renderArr: any[] = []
      for (let i = 0; i < stepItems?.length; ) {
        renderArr.push(
          <div className="relative mb-8 flex w-full justify-between" key={i}>
            <div className={`left-item w-2/5 ${!stepItems[i]?.isJustImage ? 'flex-vertical-center' : ''}`}>
              {getTextOrImage(stepItems[i])}
            </div>
            <div className={`right-item w-2/5 ${!stepItems[i + 1]?.isJustImage ? 'flex-vertical-center mr-32' : ''}`}>
              {getTextOrImage(stepItems[i + 1])}
            </div>
          </div>
        )
        i += 2
      }
      return renderArr
    }
    return null
  }

  const renderMobileView = () => {
    const imgArr: any[] = []
    const contentArr: any[] = []

    for (let i = 0; i < stepItems?.length; i++) {
      if (stepItems[i].isJustImage) {
        imgArr.push(stepItems[i])
      } else {
        contentArr.push(stepItems[i])
      }
    }

    if (stepItems) {
      let im = 0
      let co = 0
      return stepItems.map((_stepItem, j) => {
        let _obj = (j + 1) % 2 === 0 ? imgArr[im++] : contentArr[co++]
        return (
          <div key={j} className="py-4">
            <div className={`w-full ${_obj.isJustImage ? '-ml-12' : ''}`}>{getTextOrImage(_obj)}</div>
          </div>
        )
      })
    }
    return null
  }

  const renderContent = () => {
    if (isMobile) {
      return (
        <div className="mobile-view relative block flex overflow-hidden sm:hidden">
          <div className="line-wrapper-mobile" id="line-wrapper-mobile">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 98 2522"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="svg-stroke"
            >
              <path
                d="M62.45 17C30.3232 146.026 -24.2924 455.287 14.2598 660.128C52.812 864.969 102.259 1044.71 87.2435 1367.27C72.2277 1689.83 -28.6923 1718.34 14.2598 2074.41C57.2119 2430.48 37.6565 2521 37.6565 2521"
                className="path"
                stroke="black"
              />
              <path
                d="M62.45 17C30.3232 146.026 -24.2924 455.287 14.2598 660.128C52.812 864.969 102.259 1044.71 87.2435 1367.27C72.2277 1689.83 -28.6923 1718.34 14.2598 2074.41C57.2119 2430.48 37.6565 2521 37.6565 2521"
                className="mask"
                stroke={backgroundColor}
              />
              <path
                d="M50.6131 10.2973L71.1741 19.5236C68.6263 25.2014 61.9584 27.7388 56.2805 25.1909C50.6026 22.6431 48.0653 15.9752 50.6131 10.2973Z"
                fill="#F58C82"
              />
              <path
                d="M71.1735 19.5068L50.6125 10.2805C53.1603 4.60263 59.8282 2.06532 65.5061 4.61313C71.184 7.16094 73.7213 13.8289 71.1735 19.5068Z"
                fill="#006685"
              />
              <path
                d="M20.6131 735.297L41.1741 744.524C38.6263 750.201 31.9584 752.739 26.2805 750.191C20.6026 747.643 18.0653 740.975 20.6131 735.297Z"
                fill="#F58C82"
              />
              <path
                d="M41.1735 744.507L20.6125 735.281C23.1603 729.603 29.8282 727.065 35.5061 729.613C41.184 732.161 43.7213 738.829 41.1735 744.507Z"
                fill="#006685"
              />
              <path
                d="M24.6131 2277.3L45.1741 2286.52C42.6263 2292.2 35.9584 2294.74 30.2805 2292.19C24.6026 2289.64 22.0653 2282.98 24.6131 2277.3Z"
                fill="#F58C82"
              />
              <path
                d="M45.1735 2286.51L24.6125 2277.28C27.1603 2271.6 33.8282 2269.07 39.5061 2271.61C45.184 2274.16 47.7213 2280.83 45.1735 2286.51Z"
                fill="#006685"
              />
              <path
                d="M72.6131 1434.3L93.1741 1443.52C90.6263 1449.2 83.9584 1451.74 78.2805 1449.19C72.6026 1446.64 70.0653 1439.98 72.6131 1434.3Z"
                fill="#F58C82"
              />
              <path
                d="M93.1735 1443.51L72.6125 1434.28C75.1603 1428.6 81.8282 1426.07 87.5061 1428.61C93.184 1431.16 95.7213 1437.83 93.1735 1443.51Z"
                fill="#006685"
              />
            </svg>
          </div>
          <div className="mobile-content-wrapper w-4/5">{renderMobileView()}</div>
        </div>
      )
    }
    return (
      <div className="desktop-view relative hidden overflow-hidden sm:block" id="desktop-view">
        <div className="line-wrapper-desktop" id="line-wrapper-desktop">
          <svg
            className="svg-stroke"
            width="100%"
            height="100%"
            viewBox="0 0 187 1039"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="st0 path"
              stroke="black"
              d="M81.5,15.4C60,74.2,17.8,232.5,20.7,395c0.9,50.9,15.7,95.5,36,138.9c10.1,21.7,21.7,43.2,33.5,65
	          c11.9,21.8,24,44,35.5,67.3c46,92.9,80.7,202.2,37.9,369.6"
            />
            <path
              className="st0 mask"
              stroke={backgroundColor}
              d="M81.5,15.4C60,74.2,17.8,232.5,20.7,395c0.9,50.9,15.7,95.5,36,138.9c10.1,21.7,21.7,43.2,33.5,65
	          c11.9,21.8,24,44,35.5,67.3c46,92.9,80.7,202.2,37.9,369.6"
            />

            <path
              d="M144.907 1041L171.234 1052.81C167.971 1060.08 159.434 1063.33 152.163 1060.07C144.893 1056.81 141.644 1048.27 144.907 1041Z"
              fill="#F58C82"
            />
            <path
              d="M171.328 1052.98L145.001 1041.16C148.263 1033.89 156.801 1030.64 164.071 1033.91C171.341 1037.17 174.59 1045.71 171.328 1052.98Z"
              fill="#006685"
            />
            <path
              d="M119.314 624.447L94.146 638.563C90.248 631.613 92.722 622.819 99.672 618.921C106.622 615.023 115.416 617.497 119.314 624.447Z"
              fill="#F58C82"
            />
            <path
              d="M38.5363 312.439L13.3686 326.554C9.47064 319.604 11.9447 310.811 18.8947 306.913C25.8447 303.015 34.6383 305.489 38.5363 312.439Z"
              fill="#F58C82"
            />
            <path
              d="M68.4186 15.5393L94.9524 26.8805C91.8205 34.2077 83.3421 37.6086 76.0149 34.4767C68.6877 31.3449 65.2868 22.8665 68.4186 15.5393Z"
              fill="#F58C82"
            />
            <path
              d="M94.1473 638.564L119.315 624.448C123.213 631.398 120.739 640.192 113.789 644.09C106.839 647.988 98.0453 645.514 94.1473 638.564Z"
              fill="#006685"
            />
            <path
              d="M13.3699 326.559L38.5376 312.443C42.4356 319.393 39.9616 328.187 33.0116 332.085C26.0616 335.983 17.2679 333.509 13.3699 326.559Z"
              fill="#006685"
            />
            <path
              d="M94.9505 26.8723L68.4168 15.5311C71.5486 8.20392 80.027 4.80303 87.3542 7.93487C94.6815 11.0667 98.0823 19.5451 94.9505 26.8723Z"
              fill="#006685"
            />
          </svg>
        </div>
        {renderDesktopView()}
      </div>
    )
  }

  return (
    <div className="bg-white" style={{ backgroundColor }} id="step-items-parent">
      <div className="container mx-auto">{renderContent()}</div>
    </div>
  )
}

export default StepsThree

Builder.registerComponent(StepsThree, {
  name: 'StepsThree',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'stepItems',
      type: 'list',
      subFields: [
        { name: 'stepTitle', type: 'text', defaultValue: 'Sales Support' },
        {
          name: 'stepDescription',
          type: 'text',
          defaultValue: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis'
        },
        { name: 'stepImage', type: 'file', defaultValue: null },
        { name: 'isJustImage', type: 'boolean', defaultValue: false }
      ]
    }
  ]
})
